import { enqueueSnackbar } from "notistack";
import React, { useState } from "react";
import ConfirmComp from "src/components/shared/ConfirmComp";
import DeleteIcon from "src/components/shared/icon/DeleteIcon";
import UpdateIcon from "src/components/shared/icon/UpdateIcon";
import useAppGlobal from "src/context/useAppGlobal";
import useWarehouseRemove from "src/hooks/warehouse/useWarehouseRemove";
import { v4 as uuid } from "uuid";
import WarehouseCreate from "../WarehouseCreate";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";

export default function useWarehouseAction({ warehouseRole }) {
  const permissionCheck = useRoleCheck();
  const { handleOpenDialog, closeDialog } = useAppGlobal();
  const [warehouseId, setWarehouseId] = useState();
  const { trigger: removeWarehouse } = useWarehouseRemove(warehouseId);

  const handleUpdateWarehouse = (item) => {
    handleOpenDialog({
      title: "Chỉnh sửa kho hàng",
      size: "md",
      content: <WarehouseCreate item={item} />,
    });
  };

  const handleRemoveWarehouse = async (item) => {
    const res = await removeWarehouse();
    if (res?.success) {
      closeDialog();
      return enqueueSnackbar("Thành công!", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };
  const action = [
    {
      id: uuid(),
      disabled: !permissionCheck([PERMISSIONS.UPDATE_WAREHOUSE_ALL, PERMISSIONS.UPDATE_WAREHOUSE_OWN]),
      icon: <UpdateIcon disabled={!permissionCheck([PERMISSIONS.UPDATE_WAREHOUSE_ALL, PERMISSIONS.UPDATE_WAREHOUSE_OWN])} />,
      onClick: (item) => handleUpdateWarehouse(item),
      type: "icon",
    },
    {
      id: uuid(),
      disabled: !permissionCheck([PERMISSIONS.DELETE_WAREHOUSE_ALL, PERMISSIONS.DELETE_WAREHOUSE_OWN]),
      icon: <DeleteIcon disabled={!permissionCheck([PERMISSIONS.DELETE_WAREHOUSE_ALL, PERMISSIONS.DELETE_WAREHOUSE_OWN])} />,
      onClick: (item) => {
        setWarehouseId(item?._id);
        handleOpenDialog({
          content: (
            <ConfirmComp
              name={item?.name}
              onConfirm={() => handleRemoveWarehouse(item?._id)}
            />
          ),
          size: "md",
        });
      },
      type: "icon",
    },
  ];
  return action;
}
